/* Prezentolove — silnik ruchu (runda 5)
   kurtyna wejścia · odsłanianie z kaskadą · parallax · lampki
   · kalendarz 3D · rozpakowanie prezentu w newsletterze
   Bez JS-a treść jest widoczna (klasę .pz-anim dokłada pz-promo). */
(function () {
  'use strict';
  if (window.__pz5) return;
  window.__pz5 = true;

  var spokoj = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dotyk = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var GWIAZDKA = '<svg viewBox="0 0 24 24"><path d="M12 1.5c.6 5.6 4.9 9.9 10.5 10.5-5.6.6-9.9 4.9-10.5 10.5-.6-5.6-4.9-9.9-10.5-10.5C7.1 11.4 11.4 7.1 12 1.5Z"/></svg>';

  /* ---------- 1. kurtyna na wejściu (raz na sesję) ---------- */
  function kurtyna() {
    if (spokoj || !document.body) return;
    try { if (sessionStorage.getItem('pzIntro') === '1') return; } catch (e) {}
    if (document.querySelector('.pz-intro')) return;

    var el = document.createElement('div');
    el.className = 'pz-intro';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="pz-intro__in">' +
      '<span class="pz-intro__mark">' + GWIAZDKA + '</span>' +
      '<span class="pz-intro__word">Prezentolove</span>' +
      '<span class="pz-intro__line"></span></div>';
    document.body.appendChild(el);
    try { sessionStorage.setItem('pzIntro', '1'); } catch (e) {}

    var zdjete = false;
    function zdejmij() {
      if (zdjete) return;
      zdjete = true;
      el.classList.add('is-done');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 800);
    }
    var czekaj = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    czekaj.then(function () { setTimeout(zdejmij, 260); });
    setTimeout(zdejmij, 1600);
    window.addEventListener('pagehide', zdejmij);
  }

  /* ---------- 2. odsłanianie sekcji z kaskadą ---------- */
  function oznaczDzieci(root) {
    var grupy = (root || document).querySelectorAll('[data-pz-kaskada]');
    for (var i = 0; i < grupy.length; i++) {
      var dzieci = grupy[i].children;
      var krok = parseInt(grupy[i].getAttribute('data-pz-kaskada'), 10) || 90;
      for (var j = 0; j < dzieci.length; j++) {
        if (!dzieci[j].hasAttribute('data-pz-a')) dzieci[j].setAttribute('data-pz-a', 'up');
        dzieci[j].style.setProperty('--pz-d', (j * krok) + 'ms');
      }
    }
  }

  // Po animacji zdejmujemy atrybut — gdyby przeglądarka wstrzymała przejścia
  // (karta w tle, oszczędzanie energii), treść i tak będzie widoczna.
  function pokaz(el) {
    el.classList.add('is-in');
    el.setAttribute('data-pz-odsloniete', '');
    setTimeout(function () { el.removeAttribute('data-pz-a'); }, 1400);
  }

  function odsloniec(root) {
    oznaczDzieci(root);
    var cele = (root || document).querySelectorAll('[data-pz-a]:not(.is-in)');
    if (!cele.length) return;
    if (spokoj || !window.innerHeight || !('IntersectionObserver' in window)) {
      for (var i = 0; i < cele.length; i++) pokaz(cele[i]);
      return;
    }
    var obs = new IntersectionObserver(function (wpisy, o) {
      for (var k = 0; k < wpisy.length; k++) {
        if (!wpisy[k].isIntersecting) continue;
        pokaz(wpisy[k].target);
        o.unobserve(wpisy[k].target);
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    for (var m = 0; m < cele.length; m++) obs.observe(cele[m]);

    // Siatka bezpieczeństwa: gdyby obserwator nie zadziałał (karta w tle,
    // stara przeglądarka, oszczędzanie energii), pilnujemy tego sami.
    function ratuj() {
      var h = window.innerHeight || document.documentElement.clientHeight || 0;
      var z = document.querySelectorAll('[data-pz-a]:not(.is-in)');
      if (!z.length) return true;
      if (!h) { for (var j = 0; j < z.length; j++) pokaz(z[j]); return true; }
      for (var i = 0; i < z.length; i++) {
        var r = z[i].getBoundingClientRect();
        if (r.top < h * 0.96 && r.bottom > -60) pokaz(z[i]);
      }
      return false;
    }
    var tik;
    window.addEventListener('scroll', function () {
      if (tik) return;
      tik = setTimeout(function () { tik = null; ratuj(); }, 140);
    }, { passive: true });
    window.addEventListener('resize', ratuj, { passive: true });

    // Cykliczny dozór: gęsto na początku, rzadziej później — i nigdy się nie
    // wyłącza, dopóki zostało coś do odsłonięcia. Koszt: kilka pomiarów na sekundę.
    var start = Date.now();
    (function dozor() {
      if (ratuj()) return;
      setTimeout(dozor, (Date.now() - start < 45000) ? 260 : 1200);
    })();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) ratuj();
    });

    // Ostatnia deska ratunku: jeśli po 3 s nic się nie odsłoniło, znaczy że
    // obserwator nie działa — pokazujemy wszystko, nawet bez animacji.
    setTimeout(function () {
      if (document.querySelectorAll('[data-pz-a].is-in, [data-pz-odsloniete]').length) return;
      var z = document.querySelectorAll('[data-pz-a]:not(.is-in)');
      for (var i = 0; i < z.length; i++) pokaz(z[i]);
    }, 3000);
  }

  /* ---------- 3. delikatny parallax ---------- */
  function parallax() {
    if (spokoj) return;
    var cele = document.querySelectorAll('[data-pz-par]');
    if (!cele.length) return;
    var czeka = false;
    function licz() {
      czeka = false;
      var h = window.innerHeight;
      if (!h) return;
      for (var i = 0; i < cele.length; i++) {
        var el = cele[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -120 || r.top > h + 120) continue;
        var sila = parseFloat(el.getAttribute('data-pz-par')) || 0.05;
        var srodek = r.top + r.height / 2 - h / 2;
        el.style.transform = 'translate3d(0,' + (-srodek * sila).toFixed(1) + 'px,0)';
      }
    }
    window.addEventListener('scroll', function () {
      if (czeka) return;
      czeka = true;
      requestAnimationFrame(licz);
    }, { passive: true });
    licz();
  }

  /* ---------- 4. kalendarz: spokojny obrót za kursorem ---------- */
  function kalendarz() {
    var box = document.querySelector('[data-pz-adv]');
    if (!box || box.__pz) return;
    box.__pz = 1;

    if (!spokoj && !dotyk) {
      var docelowyX = 0, docelowyY = 0, klatka = null;
      function rysuj() {
        klatka = null;
        box.style.transform = 'rotateY(' + docelowyX.toFixed(2) + 'deg) rotateX(' + docelowyY.toFixed(2) + 'deg)';
      }
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        if (!r.width) return;
        docelowyX = ((e.clientX - r.left) / r.width - 0.5) * 6;
        docelowyY = ((e.clientY - r.top) / r.height - 0.5) * -5;
        box.classList.add('is-rusza');
        if (!klatka) klatka = requestAnimationFrame(rysuj);
      }, { passive: true });
      box.addEventListener('mouseleave', function () {
        box.classList.remove('is-rusza');
        box.style.transform = '';
      });
    }

    // na telefonie kilka okienek otwiera się samo, gdy sekcja wjedzie w widok
    if (dotyk && !spokoj && 'IntersectionObserver' in window) {
      var drzwi = box.querySelectorAll('.pz-door:not(.is-open)');
      var obs = new IntersectionObserver(function (w, o) {
        if (!w[0].isIntersecting) return;
        o.disconnect();
        var kolejka = Array.prototype.slice.call(drzwi).sort(function () { return Math.random() - 0.5; }).slice(0, 4);
        kolejka.forEach(function (d, i) {
          setTimeout(function () {
            d.classList.add('is-open');
            setTimeout(function () { d.classList.remove('is-open'); }, 2400 + i * 200);
          }, 600 + i * 500);
        });
      }, { threshold: 0.3 });
      obs.observe(box);
    }
  }

  /* ---------- 5. newsletter: rozpakowanie prezentu ---------- */
  function prezent() {
    var gift = document.querySelector('[data-pz-nlgift]');
    if (!gift || gift.__pz) return;
    gift.__pz = 1;
    var kod = gift.querySelector('[data-pz-nl-code]');
    var zapisany = /customer_posted=true/.test(window.location.search);
    // Kod chowamy dopiero stąd — gdyby skrypt padł, kod i tak będzie widoczny.
    if (zapisany && kod && !spokoj) gift.classList.add('pz-nlgift--czeka');

    function iskry() {
      if (spokoj) return;
      var wrap = gift.querySelector('.pz-iskry');
      if (!wrap || wrap.childElementCount) return;
      for (var i = 0; i < 18; i++) {
        var s = document.createElement('span');
        s.className = 'pz-iskra';
        s.innerHTML = GWIAZDKA;
        s.style.left = (10 + Math.random() * 80) + '%';
        s.style.top = (30 + Math.random() * 40) + '%';
        s.style.setProperty('--pz-ix', (Math.random() * 180 - 90).toFixed(0) + 'px');
        s.style.setProperty('--pz-iy', (-60 - Math.random() * 90).toFixed(0) + 'px');
        s.style.setProperty('--pz-id', (Math.random() * 0.5).toFixed(2) + 's');
        var rozmiar = (7 + Math.random() * 9).toFixed(0) + 'px';
        s.style.width = rozmiar;
        s.style.height = rozmiar;
        wrap.appendChild(s);
      }
    }
    function otworz(opoznienie) {
      setTimeout(function () {
        gift.classList.add('is-open');
        iskry();
        if (kod) {
          kod.hidden = false;
          setTimeout(function () { kod.classList.add('is-in'); }, 40);
        }
      }, opoznienie || 0);
    }

    if (zapisany) {
      // Czekamy, aż prezent naprawdę będzie widoczny — inaczej pokaz leci „w tle".
      // Pilnujemy tego na trzy sposoby, żeby kod nigdy nie został niewidoczny.
      var start = false;
      function odpal(opoznienie) {
        if (start) return;
        start = true;
        otworz(opoznienie);
      }
      if (spokoj || !window.innerHeight || !('IntersectionObserver' in window)) {
        odpal(0);
      } else {
        var obs = new IntersectionObserver(function (w, o) {
          if (!w[0].isIntersecting) return;
          o.disconnect();
          odpal(320);
        }, { threshold: 0.35 });
        obs.observe(gift);

        // dozór na wypadek, gdyby obserwator nie zadziałał
        var czas = Date.now();
        (function pilnuj() {
          if (start) return;
          var h = window.innerHeight || document.documentElement.clientHeight || 0;
          var r = gift.getBoundingClientRect();
          if (h && r.top < h * 0.8 && r.bottom > h * 0.15) return odpal(200);
          if (Date.now() - czas > 4000) return odpal(0); // ostatecznie i tak pokazujemy kod
          setTimeout(pilnuj, 220);
        })();
      }
    }

    var form = gift.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var mail = form.querySelector('input[type=email]');
        if (mail && mail.value && mail.checkValidity()) gift.classList.add('is-rwie');
      });
    }
  }

  /* ---------- 6. lampki: losowe migotanie i kołysanie ---------- */
  function lampki() {
    var listy = document.querySelectorAll('[data-pz-lampki]');
    for (var i = 0; i < listy.length; i++) {
      var lista = listy[i];
      if (lista.__pz) continue;
      lista.__pz = 1;
      var szer = lista.getBoundingClientRect().width || document.documentElement.clientWidth || window.innerWidth || 1440;
      var odstep = 64;
      var ile = Math.max(8, Math.ceil(szer / odstep) + 2);
      var html = '';
      for (var j = 0; j < ile; j++) {
        var x = (j * odstep).toFixed(0);
        var zwis = (j % 2 === 0) ? 0 : 5;
        html += '<li class="pz-bulb2" style="left:' + x + 'px;top:' + zwis + 'px;' +
          '--pz-tw:' + (2.4 + Math.random() * 2.6).toFixed(2) + 's;' +
          '--pz-td:' + (Math.random() * 2.5).toFixed(2) + 's"><b></b><i></i></li>';
      }
      lista.innerHTML = html;
    }
  }

  /* ---------- 7. miękkie przejście między podstronami ---------- */
  function przejscia() {
    if (spokoj) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.getAttribute('rel') === 'external') return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      if (/\/cart\/(add|change|update)/.test(url.pathname)) return;
      e.preventDefault();
      document.documentElement.classList.add('pz-wychodzi');
      setTimeout(function () { window.location.href = a.href; }, 170);
      setTimeout(function () { document.documentElement.classList.remove('pz-wychodzi'); }, 1800);
    });
    window.addEventListener('pageshow', function () { document.documentElement.classList.remove('pz-wychodzi'); });
  }

  function start() {
    kurtyna();
    przejscia();
    odsloniec();
    parallax();
    kalendarz();
    prezent();
    lampki();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.addEventListener('resize', function () {
    clearTimeout(window.__pz5r);
    window.__pz5r = setTimeout(function () {
      var l = document.querySelectorAll('[data-pz-lampki]');
      for (var i = 0; i < l.length; i++) l[i].__pz = 0;
      lampki();
    }, 300);
  });

  document.addEventListener('shopify:section:load', function (e) {
    odsloniec(e.target);
    lampki();
    kalendarz();
    prezent();
  });
})();
